import React from 'react'

const PublicationDocsIcon = ({props}) => (
    <svg 
        fill="currentColor" 
        viewBox="0 0 24 24" 
        xmlns="http://www.w3.org/2000/svg" 
        id="file-check" 
        className="icon glyph"
        {...props}
    >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
            <path 
                d="M18,7.41v7.35l-2,2-.88-.88a3,3,0,1,0-4.24,4.24l.88.88H4a2,
                2,0,0,1-2-2V4A2,2,0,0,1,4,2h8.59A2,2,0,0,1,14,2.59L17.41,6A2,
                2,0,0,1,18,7.41Zm-1.29,14.3,5-5a1,1,0,0,0-1.42-1.42L16,
                19.59l-2.29-2.3a1,1,0,0,0-1.42,1.42l3,3a1,1,0,0,0,1.42,0Z"
            >
            </path>
        </g>
    </svg>
)

export default PublicationDocsIcon